const findComposerAttachmentScopeKeyByAttachmentId = ({ attachmentId = null, attachmentsByScope = {} } = {}) => {
  const normalizedAttachmentId = String(attachmentId || '').trim();

  if (!normalizedAttachmentId || !attachmentsByScope || typeof attachmentsByScope !== 'object') {
    return null;
  }

  for (const [scopeKey, items] of Object.entries(attachmentsByScope)) {
    if (
      Array.isArray(items) &&
      items.some((item) => {
        return String(item?.id || '').trim() === normalizedAttachmentId;
      })
    ) {
      return scopeKey;
    }
  }

  return null;
};

export default findComposerAttachmentScopeKeyByAttachmentId;
